export default __webpack_public_path__ + "static/16_9-fd154deb5c06e2ebd8a54f3456c07839.png";